import React, { Component } from 'react';
import PropTypes from 'prop-types';
import UiComponent from '../UiComponent';
import './style.css';

export default class UserPhoto extends UiComponent {
    constructor(props) {
        super(props);

        this.onRender = this.onRender.bind(this);
        this.onUpload = this.onUpload.bind(this);
        this.onRemove = this.onRemove.bind(this);
    }

    onRender(type, elem) {
        if (this.props.onRender) {
          return this.props.onRender({type, elem});
        }
    
        return elem;
    }

    onUpload(event){
        if (event.target.files && event.target.files[0]) {
            let img = event.target.files[0];

            const {onUpload, userId } = this.props;

            if (onUpload){
                onUpload(userId, img);
            }
            // else {
            //     this.setState({
            //         src: URL.createObjectURL(img)
            //     });
            // }
          }
    }

    onRemove(){
        const { onRemove, userId } = this.props;
        if (onRemove) {
            onRemove(userId);
        }
    }

    render() {
        const containerClass = `form-group user-photo ${this.props.className}`;
        const { field, canUpload, canDelete } = this.props;
        const fileClick = e => this.fileRef.click();

        const src = field && field.value;
        console.log('load photo: ' + src);

        return (<div className={containerClass}>
            {this.onRender('label', this.getLabel())}
            {this.onRender('img', (
            <img 
                src={src} 
                title="Photo"
                // onError={({currentTarget}) => {
                //     currentTarget.onerror = null;
                //     currentTarget.src = '/assets/empty-user-photo.png'
                // }}
            ></img>))}
            {canUpload && (<input type="file" ref={ref => this.fileRef = ref} onChange={this.onUpload} style={{display: 'none'}} />)}
            <div className="actions">
                {canUpload && (<button type="button" className="btn btn-default btn-outline" onClick={fileClick}>Upload</button>)}
                {canDelete && (<button type="button" className="btn btn-default btn-outline" onClick={this.onRemove}>Delete</button>)}
            </div>
            {this.onRender('error', this.getErrors())}
        </div>);
    }
}

UserPhoto.propTypes = {
    field: PropTypes.object.isRequired,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    onUpload: PropTypes.func
  };
  


// WEBPACK FOOTER //
// ./src/common/UserPhoto/index.js